import { defineMessages } from 'react-intl';

export default defineMessages({
  dialogTitle: {
    id: 'frontbucket.branches.mergeDialogTitle',
    description: 'Text for the merge dialog title',
    defaultMessage: 'Merge changes',
  },
  actionName: {
    id: 'frontbucket.branches.mergeActionName',
    description: 'Text for the merge button in the merge dialog',
    defaultMessage: 'Merge',
  },
  mergeStrategySelectLabel: {
    id: 'frontbucket.branches.mergeStrategySelectLabel',
    description: 'Label the merge strategy selector',
    defaultMessage: 'Merge strategy',
  },
  mergeCommitStrategyLabel: {
    id: 'frontbucket.branches.mergeCommitStrategyLabel',
    description: 'Text for the merge commit strategy label',
    defaultMessage: 'Merge commit',
  },
  squashStrategyLabel: {
    id: 'frontbucket.branches.squashStrategyLabel',
    description: 'Text for the squash strategy label',
    defaultMessage: 'Squash',
  },
  fastForwardStrategyLabel: {
    id: 'frontbucket.branches.fastForwardStrategyLabel',
    description: 'Text for the fast forward strategy label',
    defaultMessage: 'Fast forward',
  },
});
